<template>
  <f7-page id="axsr-reg-details" name="axsr-reg-details" @page:beforein="init()" @page:afterin="afterin" class="bg-color-white">
    <f7-navbar class="view-mobile no-hairline bg-color-white axs-register">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="fw-bold fs-24">{{$t('general-btn-register')}}</div>
        <div><img :src="require('@/assets/img/logo-wandr_e.svg')" style="height: 15px"  class="logo"/></div>
      </div>
    </f7-navbar>

    <f7-block>
      <transition name="fade" class="">
        <f7-card
            class   ="alert alert-danger mb-20"
            v-show  ="alertCard.show"
        >
          <f7-card-header>
            <span v-html="alertCard.title"></span>
          </f7-card-header>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
      </transition>

      <f7-button large fill class="bg-color-red2 text-color-white mb-20 display-flex align-items-center justify-content-center b fs-16" @click="singpassRegister" :disabled="false">
        Register with <img :src="require('@/assets/img/icon/icon-singpass.svg')" class="ml-sm img-white" style="height:15px; margin-top: 6px;" />
      </f7-button>

      <div class="text-align-center mb-xl">
        <div class="div-button ios mb-20" @click="openAppleSignIn"><f7-icon f7="logo_apple" size="20px" class="mr-sm"></f7-icon> {{$t('general-text-apple-sign-up')}}</div>

        <div class="div-button google" @click="openGoogleSignIn">
          <img :src="require('@/assets/img/icon/icon-google-colors.svg')" style="height:20px" class="mr-sm"/> {{$t('general-text-google-sign-up')}}
        </div>        
      </div>

      <div class="my-2 re-anchor-wrapper">
        <Recaptcha v-if="isShowRecaptchaV2 && sitekeyV2 != ''" :sitekey="sitekeyV2" name="login" @validate-form="validateNextButton"/>
      </div>    

    </f7-block>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import Recaptcha from '../../components/Recaptcha.vue';
  //import SlideVerify from '../../components/SlideVerify.vue';
  //import ApiService from "../../services/api-main";
  //import CryptoAES from 'aes-ecb'
  import store from '../../store'
  //import { check } from '@/plugins/helper';
  import { dateHelper } from '@/plugins/helper';

  export default {
    mounted (){
      // const appRedirPath = this.$api.misc.checkDeviceRedirect()
      // if(appRedirPath){ window.location.href = appRedirPath; return; }
      this.determineAppBranchId(this.$f7.device.desktop)
      const rc = this.$f7route.query['rc'];

      if(rc && rc.trim() != ""){
        this.setReferral(rc);
      }

      this.getRecaptchaKey().then(()=>{
        if(this.sitekey != "" && this.sitekeyV2 != ""){
            this.loadScriptByURL("recaptcha-key", "https://www.google.com/recaptcha/api.js?render="+this.sitekey, function () {
              console.log("script loaded");
            });

            var registrationData = store.state.registration;
            registrationData.recaptchaV2 = "";

            this.forceRerender();
        }
      });

      this.setSingpassUrl("");
      this.setIsAxsr(true);
      window.regMyInfoComplete = this.regMyInfoComplete
      window.checkClosedWindowState = this.checkClosedWindowState
    },
    data() {
      return {
        sitekey               : "",
        sitekeyV2             : "",
        recaptcha             : "",
        recaptchaV2           : "",
        isPassword2Valid      : false,
        isNextButtonValid     : false,
        isShowRecaptchaV2     : false,
        msg                   : "",
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        isSingpass            : false,
        isOpenMyInfoPopup     : false,
        registerMyInfoUrl     : "",
        checkWindow           : undefined,
        checkTimer            : null,
        singpassKey           : 0,
        isForceClosed         : true,
        isCaptchaRefreshed    : false,
      };
    },
    methods: {
      ...mapActions('registration', [
            'getRecaptchaKey',
            'getToken',
            'getRegisterMyInfoUrl',
            'setSingpassUrl',
            'setReferral',
            'setIsAxsr'
        ]),

      ...mapActions('myinfo', [
        'setAddress',
        'setDob',
        'setEmail',
        'setEmployerName',
        'setEmploymentSector',
        'setFullname',
        'setGender',
        'setIdentificationNo',
        'setNationality',
        'setOccupation',
        'setPassExpiryDate',
        'setPassStatus',
        'setPassType',
        'setResidentialStatus',
        'setEnabledField',
        'setMyInfoState',
        'setMyInfoCode',
      ]),
      ...mapActions('misc', ['determineAppBranchId']),
      ...mapActions('auth', ['logout']),
      ...mapActions('customer', ['setCustomerAlias']),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async init(){
        await this.forceRerender();
      },

      async getRecaptchaKey(){
        this.showPreloader();
        const recaptchaKey = await this.$api.registration.getRecaptchaKey();

        if(recaptchaKey){
          if(recaptchaKey.result.siteKey && recaptchaKey.result.siteKeyV2){
            console.log("GOT THE SITEKEY")
            this.sitekey = recaptchaKey.result.siteKey;
            this.sitekeyV2 = recaptchaKey.result.siteKeyV2;
            this.hidePreloader();
          }else{
            console.log("DISPLAY ERROR MSG FOR SITEKEY NULL")
            this.hidePreloader();
            this.$f7.dialog.alert(this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
          }
        }else{ // recaptchaKey == false -> WS error
          this.sitekey = "";
          this.sitekeyV2 = "";
        }
        this.hidePreloader();

      },
      loadScriptByURL(id, url, callback){
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      },
      validateNextButton(){
        var isRecaptchaValid = false;

        if(!this.isShowRecaptchaV2 && this.sitekey != ""){
          isRecaptchaValid = true;
        }else if(this.isShowRecaptchaV2 && this.sitekeyV2 != ""){
          var registrationData = store.state.registration;
          if(registrationData.recaptchaV2.trim() != ""){
            isRecaptchaValid = true;
          }
        }

        this.isNextButtonValid = isRecaptchaValid
      },
      async goToNextPage(isSingpass){
        if(isSingpass){
          const self = this;
          self.showPreloader();

          const reqTokenSingpass = await this.$api.registration.getTokenSingpass();

          if(reqTokenSingpass.status == "WN00103"){
            const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
            const myInfoUrlPromise = await this.$api.registration.getRegisterMyInfoUrl(isUsingInAppBrowser);

            self.registerMyInfoUrl = myInfoUrlPromise.value;
            self.setSingpassUrl(myInfoUrlPromise.value);


            if(isUsingInAppBrowser) {
              self.openMyInfoInMobile(self.singpassUrl);
              self.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
                if(isUserCancel) {
                  self.regMyInfoCancel(false);
                } else {
                  self.regMyInfoComplete((state != '' && code != ''), state, code);
                }
              });
            } else if(self.checkWindow !== undefined) {
              self.checkWindow.location.replace(self.singpassUrl);
            } else {
              self.checkWindow = window.open(self.singpassUrl, '_blank', "fullscreen=1");
            }

            if(!isUsingInAppBrowser) {
              self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.regMyInfoCancel(false);} }, 1000);
            }
            //self.hidePreloader();
          }else{ // GENERAL EXCEPTION
            //this.showAlert(true, reqToken.status)
            this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            console.log("REQUEST REGISTER TOKEN ERROR! Status : "+reqTokenSingpass.status);
            this.hidePreloader();
          }
        }
      },
      checkClosedWindowState(){
        console.log("checkClosedWindowState : "+this.checkWindow.closed)
        if(this.checkWindow.closed){
          console.log("child window closed")
        }
      },
      async regMyInfoComplete(isNextPage, myInfoState, myInfoCode){
        this.isForceClosed = false;
        this.setMyInfoState(myInfoState);
        this.setMyInfoCode(myInfoCode);
        this.closePopupOnMobile();
        this.isSingpass = false;
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }

        if(isNextPage){
          this.showPreloader();

          const myInfoDetailPromise = await this.$api.registration.getRegisterMyInfoDetail(this.isMyInfoUseInAppBrowser(), myInfoCode, myInfoState);

          if(myInfoDetailPromise.status == "4854"){
            const myInfoData = myInfoDetailPromise.result;

            this.setAddress(myInfoData.address.streetAddress);

            // FORMAT DOB
            const dobVal = new Date(myInfoData.dateOfBirth);
            var formattedToday = '';
            if(dobVal instanceof Date && !isNaN(dobVal)) {
              const yyyy = dobVal.getFullYear();
              let mm = dobVal.getMonth() + 1; // Months start at 0!
              let dd = dobVal.getDate();

              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;

              formattedToday = dd + '-' + mm + '-' + yyyy;
            }
            //console.log("formattedToday 1 : "+formattedToday)
            this.setDob(formattedToday);
            // END OF FORMAT DOB

            this.setEmail(myInfoData.email);
            this.setEmployerName(myInfoData.employer);
            this.setEmploymentSector(myInfoData.industry);
            this.setFullname(myInfoData.name);
            this.setGender(myInfoData.gender);
            this.setIdentificationNo(myInfoData.identificationNo);
            this.setNationality({id: myInfoData.nationalityId, name: myInfoData.nationality});
            this.setOccupation(myInfoData.occupation);
            this.setPassExpiryDate(dateHelper.formatDateOnly(myInfoData.idExpiryDate));
            this.setPassStatus(myInfoData.idStatus || "");
            this.setPassType(myInfoData.identificationType);
            this.setResidentialStatus({id: myInfoData.residentialStatusId, name: myInfoData.residentialStatus || ""});
            this.setEnabledField(myInfoData.enabledField);

            this.$f7router.navigate("/register-myinfo-verify-detail");
            this.hidePreloader();
          }else if(myInfoDetailPromise.status == "0104"){
            console.log("ID exist")

            this.validateNextButton();

            this.showAlert(true, this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            this.$f7router.navigate("/register");
            this.hidePreloader();

          }else{
            console.log("get details: ERROR -> "+myInfoDetailPromise.status);
            this.$f7router.navigate("/register");
            this.hidePreloader();
          }


        }else{ // reload register enter details page
          console.log("reload page")
          //this.$f7router.navigate("/register");
          this.$f7router.refreshPage({
            url: '/register'
          });
          this.showAlert(true, this.$t('regis-myinfo-unavailable-error'));
        }
      },
      async regMyInfoCancel(isNextPage){
        console.log("isNextPage : "+isNextPage)
        this.isSingpass = false;
        await this.validateNextButton()
        this.hidePreloader();
      },
      forceRerender() {
        this.isShowRecaptchaV2 = false;
      },
      // openAppleSignInModal(){
      //   this.f7Method.loginAppleNotice.open();
      // },
      openAppleSignIn() {
        if(window.AppleID) {
          this.appleSignIn(2, false);
        }
      },
      openGoogleSignIn() {
        this.$googleAuth.requestAccessToken();
      },
      backButton() {
          switch(this.routerTo) {
              default          : this.$f7router.navigate("/"); break;
          }
      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      singpassRegister(){
        console.log("singpassRegister");
        const self = this;

        self.isSingpass = true;
        self.goToNextPage(true);
      }
    },
    components: {
      Recaptcha,
      //SlideVerify,
    },
    computed: {
      ...mapGetters('registration', ['singpassUrl','email','isAxsr']),
      ...mapGetters('myinfo', [
          'myInfoState',
          'myInfoCode',
        ])
    },
  }
</script>